import React from "react";
import { calculateAge, formatPhoneNumber, isSet } from "../../../utils/commonUtils";
import FormInputs from "../../../components/UI/FormInputs";
import Buttons from "../../../components/UI/Buttons";
 
const ActivityConsent = ({ onChangeHandler, patientFormData, formData, validation }) => {
  const { employee } = patientFormData;
  console.log("patientFormData activity validation",validation);
 
  // Helper to generate input fields for each activity consent
  const generateActivityInputs = (activityConsent, index) => {
    // const activityDeclination = activityConsent?.activity_declination_list || [];
    const activityDeclination = activityConsent?.declinationmessage || [];

 
    return [
      {
        type: "Checkbox",
        label: isSet(activityConsent.authorization_message_en, ""),
        col: "col-12",
        isLabelAppend: true,
        className: "form-check-input",
        name: `authorization_message_checked_${index}`,
      },
      {
        type: "Checkbox",
        col: "col-12",
        name: `declination_message_checked_${index}`,
        isLabelAppend: true,
        className: "form-check-input",
        label: isSet(activityConsent.declination_message_en, ""),
      },
      {
        type: "Blank",
        isShow: Boolean(isSet(formData?.[`declination_message_checked_${index}`], false)),
        name: "",
      },
      {
        label: "Reasons for Declination",
        type: "SelectSearchList",
        isShow: Boolean(isSet(formData?.[`declination_message_checked_${index}`], false)),
        isMulti: true,
        options: activityDeclination.map((item) => ({
          label: item.reason_for_declination_en,
          value: item.reason_for_declination_en,
        })),
        name: `reasons_for_declination_${index}`,
      },
      {
        type: "Checkbox",
        label: "Other Reason",
        className: "form-check-input",
        isLabelAppend: true,
        isShow: Boolean(isSet(formData?.[`declination_message_checked_${index}`], false)),
        name: `is_other_reason_${index}`,
      },
      {
        label: "Specify Reason",
        type: "TextArea",
        isShow: Boolean(isSet(formData?.[`declination_message_checked_${index}`], false)),
        disabled: !isSet(formData?.[`is_other_reason_${index}`], false),
        name: `other_reason_${index}`,
      },
    //   {
    //     label: "Patient Signature/Consent",
    //     type: "Signature",
    //     className: "form-control form-control-solid",
    //     name: `patient_signature_${index}`,
    //     options: [],
    //     required: true,
    //   },
    //   {
    //     label: "Date",
    //     type: "Date",
    //     name: `consent_date_${index}`,
    //     required: true,
    //   },
    ];
  };
 
  return (
    <div>
      <div className="sh_cardHeader border-0">
        <h6 className="m-0 text-md font-weight-bold">
          <Buttons iconType="DashboardComp" className="pr-2" />
          Activity Consents
        </h6>
      </div>
      <div className="sh_cardBody">
  {patientFormData?.activity_consents &&
    Object.values(patientFormData.activity_consents).map((activityConsent, index) => {
      const inputFields = generateActivityInputs(activityConsent, index);

      // Remove signature and date fields from per-activity inputs
      const filteredInputs = inputFields.filter(f => !['patient_signature_'+index, 'consent_date_'+index].includes(f.name));

      return (
        <div key={activityConsent.activity_consent_id} className="col-12 mb-4 p-2" style={{ border: "1px solid var(--snap-common-border)", borderRadius: "10px"}}>
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h6 className="m-0 text-md font-weight-bold">
              Activity Consent for <span className="badge bg-blue-soft text-white">{activityConsent.activity_name}</span>
            </h6>
          </div>

          <div className="col-12 mb-2 p-1">
            <HTMLContent htmlString={activityConsent.activity_consent_content_en} />
          </div>

          <div className="row">
            {filteredInputs.map((field, fieldIndex) => {
              if (isSet(field.isShow, true) === false) return null;
              const activityValidation = validation || {};

              return (
                <div className={field.col || "col-12"} key={fieldIndex}>
                  <div className={`form-group consent-form-group ${isSet(field.isLabelAppend, false) ? "form-check form-check-solid" : ""}`}>
                    {!isSet(field.isLabelAppend, false) && <label className="mb-0 text-sm opacity-75 text-truncate">{field.label}</label>}

                    <FormInputs
                      {...field}
                      value={isSet(formData[field.name], "")}
                      changeHandler={(value) => onChangeHandler(field.name, value)}
                    />

                    {isSet(field.isLabelAppend, false) && <label className="form-check-label">{field.label}</label>}
                    {activityValidation[field.name] && <span className="text-danger m-1">{activityValidation[field.name]}</span>}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      );
    })}

  {/* Common Signature & Date fields */}
  <div className="col-12 mb-4 p-2" style={{ border: "1px solid var(--snap-common-border)", borderRadius: "10px", background: "#eef2f5" }}>
    <h6 className="m-0 text-md font-weight-bold mb-2">Patient Signature & Consent Date</h6>
    <div className="row">
      <div className="col-lg-6 col-md-6 col-12">
        <FormInputs
          type="Signature"
          name="patient_signature"
          value={formData.patient_signature || ""}
          changeHandler={(val) => onChangeHandler("patient_signature", val)}
          label="Patient Signature"
          required
        />
        {validation.patient_signature && <span className="text-danger m-1">{validation.patient_signature}</span>}
      </div>
      <div className="col-lg-6 col-md-6 col-12">
        <FormInputs
          type="Date"
          name="consent_date"
          value={formData.consent_date || ""}
          changeHandler={(val) => onChangeHandler("consent_date", val)}
          label="Consent Date"
          required
        />
                      {validation.consent_date && <span className="text-danger m-1">{validation.consent_date}</span>}
      </div>
    </div>
  </div>
</div>

    </div>
  );
};
 
const HTMLContent = ({ htmlString }) => {
  return <div dangerouslySetInnerHTML={{ __html: htmlString }} />;
};
 
export default ActivityConsent;